import { Currency } from '@pancakeswap-libs/sdk-v2'
import React, { useCallback, useEffect, useState } from 'react'
import OptionSearch from './OptionSearch'
import Modal from './Modal'
import { SelectItem } from './ItemInter'

interface CurrencySearchModalProps {
    onSelect: (currency: SelectItem) => void
    isOpen: boolean
    options: any
    onDismiss: () => void
}

export default function CurrencySearchModal({
    onSelect,
    onDismiss,
    isOpen,
    options
}: CurrencySearchModalProps) {
    const handleCurrencySelect = useCallback(
        (currency: SelectItem) => {
            onSelect(currency)
        },
        [onSelect]
    )

    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90} minHeight={80}>
            <OptionSearch
                onDismiss={onDismiss}
                onSelect={handleCurrencySelect}
                options={options}
            />
        </Modal >
    )
}
